import { render, staticRenderFns } from "./overallDashboard.vue?vue&type=template&id=45e8559a&scoped=true&"
import script from "./overallDashboard.vue?vue&type=script&lang=js&"
export * from "./overallDashboard.vue?vue&type=script&lang=js&"
import style0 from "./overallDashboard.vue?vue&type=style&index=0&id=45e8559a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e8559a",
  null
  
)

export default component.exports